<template>
<div class="chapter">
<div class="inner_page">
<h2 id="toc">Contents</h2>
<p class="firstverse"><a href="#/Text/Acknowldgments"><em>Acknowledgments</em></a></p>
<p class="firstverse"><a href="#/Text/Preface"><em>Preface</em></a></p>
<p class="firstverse"><a href="#/Text/Introduction"><em>Introduction</em></a></p>
<p class="firstverse"><a href="#/Text/Chap01">1: The Medieval Call for Reform</a></p>
<p class="firstverse"><span href="#/Text/Chap02" title="Link target outside of Sample">2: The Renaissance</span></p>
<p class="firstverse"><span href="#/Text/Chap03" title="Link target outside of Sample">3: Carried Along by Misunderstandings</span></p>
<p class="firstverse"><span href="#/Text/Chap04" title="Link target outside of Sample">4: Conflict Among the Reformers</span></p>
<p class="firstverse"><span href="#/Text/Chap05" title="Link target outside of Sample">5: What the Reformers Meant by <em>Sola Fide</em></span></p>
<p class="firstverse"><span href="#/Text/Chap06" title="Link target outside of Sample">6: What the Reformers Meant by <em>Sola Scriptura</em></span></p>
<p class="firstverse"><span href="#/Text/Chap07" title="Link target outside of Sample">7: How the Anabaptists Fit In</span></p>
<p class="firstverse"><span href="#/Text/Chap08" title="Link target outside of Sample">8: Reformation in Rome</span></p>
<p class="firstverse"><span href="#/Text/Chap09" title="Link target outside of Sample">9: Changing Direction</span></p>
<p class="firstverse"><span href="#/Text/Chap10" title="Link target outside of Sample">10: Was the Reformation a Success?</span></p>
<p class="firstverse"><span href="#/Text/Chap11" title="Link target outside of Sample">11: Is the Reformation a Norm?</span></p>
<p class="firstverse"><span href="#/Text/Chap12" title="Link target outside of Sample">12: The Reformation as Triumph and Tragedy</span></p>
<p class="firstverse"><span href="#/Text/NameIndex" title="Link target outside of Sample"><em>Name Index</em></span></p>
<p class="firstverse"><span href="#/Text/SubjectIndex" title="Link target outside of Sample"><em>Subject Index</em></span></p>
<p class="firstverse"><span href="#/Text/author" title="Link target outside of Sample">About the Author</span></p>
<p class="firstverse"><span href="#/Text/Endorsements" title="Link target outside of Sample">Praise for <em>Getting the Reformation Wrong</em></span></p>
<p class="firstverse"><span href="#/Text/MoreTitlesfromIVP" title="Link target outside of Sample">More Titles from InterVarsity Press</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?12d2d709